// src/components/ZibalTrustBadge.jsx
import React, { useEffect } from 'react';

export default function ZibalTrustBadge() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://zibal.ir/trust/scripts/zibal-trust-v4.js';
    script.type = 'text/javascript';
    script.async = true;

    document.getElementById('zibal-container').appendChild(script);

    // Optional: پاک‌سازی در زمان حذف کامپوننت
    return () => {
      document.getElementById('zibal-container').innerHTML = '';
    };
  }, []);

  return (
    <div
      id="zibal-container"
      style={{
        margin: 'auto',
        textAlign: 'center',
      }}
    >
      {/* لوگو توسط اسکریپت بارگذاری می‌شود */}
    </div>
  );
}
